import Vue from 'vue';

Vue.component('export-detail-index', () =>
    import(/* webpackChunkName: 'export-detail-index' */ './export-detail-index.vue'),
);
